export default __webpack_public_path__ + "static/media/47SA61_47SD610_47SJ61_47SJ62.22348e53.png";